import { gql } from "@apollo/client"

const GET_GROUP_LESSONS = gql`
  query group($id: ID!) {
    group(id: $id) {
      id
      location {
        id
        name
      }
      lessons {
        id
        name
      }
    }
  }
`

export { GET_GROUP_LESSONS }
